export default class Input {
    constructor({ root, element }) {
        this.instanceId = root.instanceId;

        this.config = root.config;
        this.main   = root.main;
        this.helper = root.helper;

        this.$element = $(element);
        this.$parent  = this.$element.parent();
        this.$icon    = this.$parent.find('.f-calendar__input-icon');
        this.$overlay = $('<div class="f-calendar__input-overlay"></div>');

        this.$element.addClass('f-calendar__element');

        this.state = {
            valid: true, // Empty is valid

            value: '',
            valueISO: '',

            // useless
            // dateValue: '',
            // timeValue: '',

            date: null,

            parsed: {
                date: null,
                month: null,
                year: null,

                hour: null,
                minute: null
            }
        };

        this.lastInputValue = '';

        // Если поле было заполнено до инита - обрабатываем значение по маске
        this.dateMask();
    }

    get isFocused() {
        return this.$element.is(':focus');
    }

    focus() {
        this.$element.focus();
    }

    blur() {
        this.$element.blur();
    }

    hideOverlay() {
        this.$overlay.hide();
    }

    showOverlay() {
        this.$overlay.show();
    }

    checkMobile() {
        const { mobile } = this.main;
        const { workTime } = this.config.get();

        // На мобильных или если есть выбор времени запрещаем свободный ввод
        const readonly = !!(mobile || workTime);

        this.$element.attr('readonly', readonly);

        if (readonly) {
            this.showOverlay();
        }
        else {
            this.hideOverlay();
        }
    }

    preBuild() {
        const $parent = this.$parent;

        this.$element.attr('autocomplete', 'off');
        this.$element.attr('element-id', this.instanceId);

        $parent.append(this.$overlay);

        this.checkMobile();
    }


    parse() {
        const inputValue = this.$element.val();

        const { type, dateFormat } = this.config.get();
        const { dateMask, timeMask, dateTimeMask } = this.config.getMasks();

        // Собираем в объект введенную дату
        const parsed = this.state.parsed;

        // Обнуляем все поля
        parsed.day = null;
        parsed.year = null;
        parsed.month = null;
        parsed.date = null;
        parsed.hour = null;
        parsed.minute = null;

        const [inputValueDate, inputValueTime] = inputValue.split(dateTimeMask.divider);

        if (inputValueDate) {
            inputValueDate
                .split(dateMask.divider)
                .forEach((value, index) => {
                    if (value == null || value == '') {
                        return;
                    }

                    value = Number(value) || null;

                    const subject = dateMask.order[index].subject;

                    if (subject === 'month') {
                        value -= 1;
                    }

                    parsed[subject] = value;
                });
        }

        if (inputValueTime) {
            inputValueTime
                .split(timeMask.divider)
                .forEach((value, index) => {
                    if (value == null || value === '') {
                        return;
                    }

                    // Приводим к числу
                    value = Number((value || '').replace(/\D/g, '')) || 0;

                    const subject = timeMask.order[index].subject;

                    parsed[subject] = value;
                });

            // Для ampm надо пересчитывать в 24 формат
            if (dateFormat.hour12) {
                const isPm = /pm/i.test(inputValueTime);

                if (parsed.hour === 12) {
                    parsed.hour = isPm ? 12 : 0;
                }
                else if (isPm) {
                    parsed.hour = 12 + parsed.hour;
                }
            }
        }

        this.state.valid = false;
        this.state.date = null;
        this.state.valueISO = '';
        this.state.dateValue = '';
        this.state.timeValue = '';

        // Пустое значение вполне валидно
        if (!inputValue) {
            this.state.valid = true;
        }
        // Заполненное проверяем на длину
        else {
            let isCompleted = parsed.year && parsed.month >= 0 && parsed.date;

            if (type === 'datetime' && isCompleted) {
                isCompleted = parsed.hour != null && parsed.minute != null;
            }

            if (isCompleted) {
                const dateInstance = this.helper.getDateFromParsed(parsed);

                parsed.day = dateInstance.getDay();

                this.state.date   = dateInstance;
                this.state.valueISO = this.helper.getISOString(dateInstance) || '';

                this.state.valid = this.validate(parsed).valid;
            }

            this.state.dateValue = this.helper.getDateStr(parsed);
            this.state.timeValue = this.helper.getTimeStr(parsed);
        }

        this.state.parsed = parsed;
        this.state.value  = inputValue;

        return this.state;
    }

    validate(parsed) {
        const { workDays, lowerLimit, upperLimit } = this.config.get();

        const dateValid = this.helper.checkDateIsValid(parsed);

        if (!dateValid) {
            return {
                valid: false,
                error: 'date_invalid'
            };
        }

        // Выбранная дата может быть недоступной, т.к выходная
        const weekDay = workDays && !workDays.includes(parsed.day);

        if (weekDay) {
            return {
                valid: false,
                error: 'weekday'
            };
        }

        // Проверяем верхние и нижние лимиты выбора дат
        const datelowerLimitValid = (
            parsed.year === lowerLimit.year &&
            parsed.month === lowerLimit.month ? parsed.date >= lowerLimit.date : true
        );

        const monthlowerLimitValid = parsed.year === lowerLimit.year ? parsed.month >= lowerLimit.month : true;

        const dateupperLimitValid = (
            parsed.year === upperLimit.year &&
            parsed.month === upperLimit.month ? parsed.date <= upperLimit.date : true
        );

        const monthupperLimitValid = parsed.year === upperLimit.year ? parsed.month <= upperLimit.month : true;

        const dateLimitValid = datelowerLimitValid && dateupperLimitValid;
        const monthLimitValid = monthlowerLimitValid && monthupperLimitValid;

        const yearLimitValid = (
            parsed.year >= lowerLimit.year &&
            parsed.year <= upperLimit.year
        );

        const limitsValid = dateLimitValid && monthLimitValid && yearLimitValid;

        if (!limitsValid) {
            return {
                valid: false,
                error: 'limit_is_exceeded'
            };
        }

        return { valid: true };
    }

    getState() {
        return this.state;
    }

    checkError() {
        // Проверяем инпут
        const inputValue = this.parse();

        if (!inputValue.valid) {
            const config = this.config.get();

            // TODO было бы неплохо определять более конкретно тип ошибки (например "выберите дату в прошлом")
            return config.locale.errors.invalid_date;
        }

        return false;
    }


    /**
    * Нормализует значение в инпуте по маске (только даты)
    */
    dateMask({ event } = {}) {
        const { type } = this.config.get();
        const { dateMask, dateTimeMask } = this.config.getMasks();

        const maxLength = (type === 'datetime') ? dateTimeMask.mask.length : dateMask.mask.length;

        const element = this.$element[0];
        const inputValue = element.value.split('');

        let cursorPosition = element.selectionStart;

        // Запрещаем вводить больше размера маски
        if (inputValue.length > maxLength) {
            this.setInputValue(this.lastInputValue, event ? false : 'change');

            element.setSelectionRange(cursorPosition - 1, cursorPosition - 1);

            return this.lastInputValue;
        }

        // Разделители дат
        const divider = dateMask.divider;
        const firstDividerPos = dateMask.order[1].position - 1;
        const secondDividerPos = dateMask.order[2].position - 1;

        const removeLetter = inputValue.length < this.lastInputValue.length;

        // Сперва вырезаем все кроме цифр
        const newInputValue = inputValue.filter(l => /[0-9]/.test(l));

        // Затем добавляем разделители
        [firstDividerPos, secondDividerPos].forEach((dividerPos) => {
            if ((!removeLetter || inputValue.length > dividerPos) && newInputValue.length >= dividerPos) {
                newInputValue.splice(dividerPos, 0, divider);

                // Сдвигаем курсор, т.к точка добавилась вперед
                if (inputValue.length === cursorPosition) {
                    cursorPosition += divider.length;
                }
            }
        });

        const value = newInputValue.join('');

        this.setInputValue(value, event ? false : 'change');

        // Фиксим позицию курсора
        element.setSelectionRange(cursorPosition, cursorPosition);

        this.lastInputValue = value;

        return value;
    }

    /**
     * Устанавливает дату в инпут (только дату)
    */
    setDate(parsed) {
        const value = this.helper.getDateStr(parsed);
        const dateInstance = this.helper.getDateFromParsed(parsed);
        const day = dateInstance.getDay() || 0;

        this.state.valid = true;
        this.state.value = value;
        this.state.date  = dateInstance;
        this.state.valueISO = this.helper.getISOString(dateInstance);
        // this.state.dateValue = value;

        this.state.parsed = {
            day,
            date:  parsed.date,
            month: parsed.month,
            year:  parsed.year
        };

        // Вставляем дату в инпут
        this.setInputValue(value);
    }

    /**
     * Устанавливает время в инпут
    */
    setTime(selectedTime) {
        // Дата не валидная, нельзя ставить время
        if (!this.state.value.length) {
            return false;
        }

        this.state.parsed.hour   = selectedTime.hour;
        this.state.parsed.minute = selectedTime.minute;

        // this.state.timeValue = this.helper.getTimeStr(this.state.parsed);
        this.state.value = this.helper.getDateAndTimeStr(this.state.parsed);
        this.state.date  = this.helper.getDateFromParsed(this.state.parsed);

        // Обновляем значение в инпуте
        this.setInputValue(this.state.value);
    }

    setInputValue(value, eventType = 'change') {
        this.$element.val(value);
        this.$element.attr('value', value);

        if (eventType) {
            const event = new Event(eventType, {
                bubbles: true,
                cancelable: true
            });

            this.$element[0].dispatchEvent(event);
        }
    }
}
